module.exports = __webpack_public_path__ + "static/img/banner_03.5381c270.png";